export default {
  legacySpacing: 30,
};
